module.exports = __webpack_public_path__ + "img/9128.3eedb8c8.jpg";